import {
  GET_VAULT_REQUEST_LIST_REQUESTED,
  GET_VAULT_REQUEST_LIST_FAILED,
  GET_VAULT_REQUEST_LIST_SUCCESS,
  CLEAR_VAULT_REQUEST_LIST_ERROR,
  CLEAR_VAULT_REQUEST_LIST,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const vaultRequestListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VAULT_REQUEST_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VAULT_REQUEST_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_VAULT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_VAULT_REQUEST_LIST_ERROR:
      return { ...state, error: null };
    case CLEAR_VAULT_REQUEST_LIST:
      return initialState;
    default:
      return state;
  }
};

export default vaultRequestListReducer;
